import React, { FC, memo, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Text } from "@/components/Text";
import { UserContext } from "@/components/User";
import { MEDIA_SIZE_MD } from "@/core/media";
import { Flex } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

interface Props extends IConsultantProfileSectionProps {
  searchable: boolean;
  role: string;
}

export const SettingsSectionReadOnly: FC<Props> = memo(({ record, searchable, role }) => {
  const { t } = useTranslation("session");
  const User = useContext(UserContext);
  const { contextCompany } = User;
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);
  const baseClass = "consultant-profile-settings";

  return (
    <Flex direction={isMediumScreen ? "column" : "row"} innerMargin="md" border={[false, false, true, false]}>
      {contextCompany && contextCompany.id && record?.companyRole && (
        <Flex width={isMediumScreen ? 12 : 6} grow={1} innerMargin="sm" direction="column">
          <Flex innerMargin="sm">
            <Text size="md" color="grey1">
              {t("CONSULTANT_PROFILES.DETAIL.SETTINGS.PROFILE_ROLE.LABEL")}
            </Text>
          </Flex>
          <Flex align="center" padding={[false, false, "md", false]}>
            <Text size="md" color="black">
              {t(`CONSULTANT_PROFILES.DETAIL.PROFILE_ROLE.${role}`)}
            </Text>
          </Flex>
        </Flex>
      )}

      {!contextCompany && (
        <Flex width={isMediumScreen ? 12 : 6} grow={1} innerMargin="sm" direction="column" className={baseClass}>
          <Flex innerMargin="sm">
            <Text size="md" color="grey1">
              {t("CONSULTANT_PROFILES.DETAIL.SETTINGS.SEARCHABLE.LABEL")}
            </Text>
          </Flex>
          <Flex align="center" padding={[false, false, "md", false]}>
            <Text size="md" color="black">
              {t(
                searchable
                  ? "CONSULTANT_PROFILES.DETAIL.SETTINGS.SEARCHABLE.SEARCHABLE_ON"
                  : "CONSULTANT_PROFILES.DETAIL.SETTINGS.SEARCHABLE.SEARCHABLE_OFF",
              )}
            </Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
});
